/* global  */
(function f($) {
    const PODCAST_API_KEY = '51dbefced35d96f7cd24b66da09291cf';
    const conf = {
        toggleMenuItems: ['#global-logo', '#the-menu-btn', '#the-menu', '#the-menu .menu-item', '.disclaimer'],
        menuBtn:         $('#the-menu-btn'),
        body:            $(document.body),
        window:          $(window),
        mc1Submitted:    false,
    };
    // Elements
    const $el = {
        menuBtn:          $('#the-menu-btn'),
        body:             $(document.body),
        window:           $(window),
        parallax:         $('.parallax'),
        parallaxBGs:      $('.parallaxBg'),
        theEditBtnSelect: $("a[data-taxonomy='the-edit']"),
        taxonomyLink:     $('a[data-taxonomy]'),
    };

    /**
     * toggle a class with a set delay multiplier on all array elements
     * @param {string} toggleClass
     * @param {number} multiplier
     */
    $.fn.toggleClassWithDelay = function f(toggleClass, multiplier, action) {
        const multi = multiplier || 250;
        let i = 1;
        this.each((f, el) => {
            setTimeout(() => {
                if (action === 'add')
                    $(el).addClass(toggleClass);
                else if (action === 'remove')
                    $(el).removeClass(toggleClass);
                else
                    $(el).toggleClass(toggleClass);
            }, i * multi);
            i += 1;
        });
        return this;
    };

    $.fn.addClassWithDelay = function f(toggleClass, multiplier) {
        return this.toggleClassWithDelay(toggleClass, multiplier, 'add');
    };

    $.fn.removeClassWithDelay = function f(toggleClass, multiplier) {
        return this.toggleClassWithDelay(toggleClass, multiplier, 'remove');
    };

    // Open the subscribe modal
    // Add to the window object so it can be called from the widget
    window.openSubscribeModal = () => $('.open-subscribe-modal').first().trigger('click');

    /**
    * Actions that take place when the menu button is clicked
    * @param {String} action Either open or close or null
    */
    function menuBtnClick(action) {
        action = action || 'open';
        // Add the initial animation class, this will only trigger once
        if (action === 'close') {
            $('.section-logo').removeClass('off');
            $el.body.removeClass('menu-open').css('overflow', '');
            $(conf.toggleMenuItems.join(',')).removeClassWithDelay('on', 50);
        } else if (action === 'open') {
            $('.section-logo', `#${$el.body.attr('data-section-id')}`).addClass('off');
            $el.body.addClass('menu-open').css('overflow', 'hidden');
            $(conf.toggleMenuItems.join(',')).addClassWithDelay('on', 50);
        }
    }

    // Trigger the menu opening animations
    $el.menuBtn.on('click', () => menuBtnClick($el.menuBtn.hasClass('on') ? 'close' : 'open'));

    function getHash() {
        return window.location.hash.substr(1);
    }

    // Cris' parallax stuff
    function parallaxFunction() {
        // If on mobile just hide all parallax activity
        if ($el.body.hasClass('state_mobiles')) {
            $el.parallaxBGs.css('opacity', 0);
            return;
        }
        const bottomOfWindow = $el.window.scrollTop() + $el.window.height();
        $el.parallax.each((index, section) => {
            const $self      = $(section);
            const objTop     = $self.position().top;
            const objBottom  = objTop + $self.outerHeight();
            const $bgElement = $el.parallaxBGs.eq(index); // $(`#${$self.attr('id')}Bg`);

            if (objTop < bottomOfWindow && objBottom > $el.window.scrollTop()) {
                $bgElement.css('opacity', 1);
                let scale = 0.15 + (bottomOfWindow / objBottom);
                scale = scale > 1 ? scale : 1;
                $bgElement.css('transform', `scale(${scale})`);
            }
            if (objTop > bottomOfWindow || objBottom < $el.window.scrollTop())
                $bgElement.css('opacity', 0);
            if (objTop < bottomOfWindow && objTop >= $el.window.scrollTop())
                $bgElement.css('opacity', (bottomOfWindow - objTop) / ($el.window.height() * 3 / 4));
            if (objBottom < bottomOfWindow && objBottom >= $el.window.scrollTop())
                $bgElement.css('opacity', (objBottom - $el.window.scrollTop()) / ($el.window.height() * 3 / 4));
        });
    }

    function changeQuarterNumber() {
        const $quarterNumber = $('#get-header-quarter').text();
        const $quarterContainer = $('#the-edit-header-svg text');
        $quarterContainer.text($quarterNumber || '');
    }

    function buzzproutAPIInit() {
        const $podcastTitle = $('.buzzsprout-latest-title');
        const $podcastDescription = $('.buzzsprout-latest-description');

        if (!$podcastTitle.length || !$podcastDescription.length)
            return;

        // Get the latest podcast title and description and link
        $.ajax({
            url:     `https://api.buzzsprout.com/api/2130810/episodes.json?api_token=${PODCAST_API_KEY}`,
            type:    'GET',
            success: (data) => {
                // console.log('Podcast data fetched', data);
                const { title, description, audio_url } = data[0];
                $podcastTitle.text(title);
                // Strip HTML from description
                $podcastDescription.text(description.replace(/<[^>]*>?/gm, ''));
            },
            error: (err) => console.error('Error fetching podcast data', err),
        });
    }

    function init() {
        buzzproutAPIInit();
        changeQuarterNumber();
        // Run this ony if the element exits
        if ($el.parallax.length)
            $el.window.on('scroll load', parallaxFunction);

        // This logic has moved to the widget file on the corp site...
        // If hash is present or has not interacted with model, open the subscribe menu
        // if (initialState.subscribe === 'true')
        // $('.subscribe-btn').trigger('click');

        // Trigger a click on section
        // Show Section
        $el.sectionBtnSelect = $(`a[data-taxonomy='${getHash()}']`);
        if ($el.sectionBtnSelect.length)
            $el.sectionBtnSelect.trigger('click');

        // Set the right hash.
        $el.taxonomyLink.on('click', function f(e) {
            e.preventDefault();
            window.location.hash = this.getAttribute('data-taxonomy');
        });
    }

    $(document).ready(init);
}(jQuery));
